import { initHomeAbout } from "./homeAbout.js";
import { initAboutTeam } from "./aboutTeam.js";
import { initAreasOfFocus } from "./areasOfFocus.js";
import { initAccordions } from "./accordion.js";
import { initPartnersCarousel } from "./partnersCarousel.js";
import { initHashScroll } from "./hashScroll.js";
import { initParallaxImages } from "./parallaxImage.js";

document.addEventListener("DOMContentLoaded", () => {
  initHomeAbout();
  initAboutTeam();
  initAreasOfFocus();
  initAccordions();
  initPartnersCarousel();
  initHashScroll();
  initParallaxImages();
});
